import React from "react";
import Button from '@mui/material/Button';
import { ValidateLabTestInput } from "./ValidateLabTestInput";
const btnsArray = [
  { operation: "Display" },
  { operation: "Change" },
  {
    operation: "Create",
    navPath: (navigate) => navigate(`/LabTest/Create`),
  },
];

export default function OverviewButtons({
  labTest,
  navigate,
  _getLabTestExists,
  _createErrorMessage,
}) {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        flexWrap: "wrap",
      }}
      className="customButton"
    >
      {btnsArray.map(({ operation, navPath }, i) => (
        <div style={{ width: "48%", marginBottom: 15 }}>
          <Button
            className="btn btn-primary w-100"
            key={operation}
            onClick={() => {
              if (operation === "Create") {
                navPath(navigate);
                return;
              }

              let validationLabTestResult = ValidateLabTestInput(
                labTest,
                _createErrorMessage
              );

              if (!validationLabTestResult) {
                return;
              }

              _getLabTestExists(
                { data: { Id: labTest } },
                ({ data: isExist }) => {
                  if (!isExist) {
                    _createErrorMessage("109");
                    return;
                  }
                  const navigationUrl = `/LabTest/${labTest}/${operation}`;
                  navigate(navigationUrl);
                }
              );
            }}
          >
            {operation}
          </Button>
        </div>
      ))}
    </div>
  );
}
